'use client'

import { Box } from '@mui/material'
import { useCallback, useState, useEffect, memo } from 'react'
import { Cancel01Icon } from '@/utils/icons'
import Image from 'next/image'

const LOCAL_STORAGE_KEY = 'backpackAdClosed'
const EXPIRATION_DAYS = 4

const BackPackAdd = (): JSX.Element => {
  const [closed, setClosed] = useState(false)

  // Check local storage for ad status
  useEffect(() => {
    const data = localStorage.getItem(LOCAL_STORAGE_KEY)
    if (data) {
      const { timestamp } = JSON.parse(data)
      const now = new Date().getTime()
      const isExpired = now - timestamp > EXPIRATION_DAYS * 24 * 60 * 60 * 1000

      if (!isExpired) {
        setClosed(true)
      } else {
        localStorage.removeItem(LOCAL_STORAGE_KEY) // Clear expired data
      }
    }
  }, [])

  // Close the ad and save state to local storage
  const close = useCallback(() => {
    setClosed(true)
    const timestamp = new Date().getTime()
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({ timestamp }))
  }, [])

  return (
    <>
      {!closed ? (
        <Box
          component='section'
          sx={{
            width: 500,
            height: 120,
            position: 'relative',
            overflow: 'hidden'
          }}
          className='rounded-xl shadow-2xl shadow-inner brightness-90'
        >
          {/* Background Image */}
          <Box className='absolute inset-0'>
            <Image
              src='https://imagedelivery.net/COrEjiX90UMaVnfrARSGdQ/c5774c4e-c150-4552-3f76-e7a053019400/public'
              alt='backpack'
              layout='fill'
              objectFit='cover'
              objectPosition='center 20%'
              priority
            />
          </Box>

          {/* Overlay */}
          <Box className='absolute inset-0' />

          {/* Content Container */}
          <Box className='relative h-full flex flex-row-reverse justify-between p-3'>
            {/* Close Button */}
            <Box className='flex justify-end h-fit z-10'>
              <Cancel01Icon
                width={15}
                className='text-white/60 cursor-pointer hover:text-white/80 transition-colors'
                onClick={close}
              />
            </Box>

            {/* Text Content */}
            <Box className='text-left w-full text-white p-1 z-10'>
              <h3 className='text-3xl font-regular leading-tight mb-1'>
                Trade using Backpack wallet
              </h3>
              <p className='text-md font-regular'>
                And get extra{' '}
                <span className='font-clash italic text-lg text-red-400'>
                  MXP
                </span>
              </p>
            </Box>
          </Box>
        </Box>
      ) : null}
    </>
  )
}

export default memo(BackPackAdd)
